import { buildQrDataUrl } from "./qrCode";

/**
 * Build a data-URL QR image for campaign share links (no external API).
 */
export async function buildCampaignQrDataUrl(text, size = 400) {
  const value = String(text || "").trim();
  if (!value) {
    throw new Error("Share URL is required to generate a QR code.");
  }
  return buildQrDataUrl(value, size);
}
